import { Component, OnInit } from '@angular/core';
import { CheckpointsService } from '../services/checkpoints.service';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  data: any[] = [];
  loading = true;
  loading_status = true
  error = '';
  lastUpdated: Date | null = null;
  downloadingMasterIds: number[] = [];
  startDate!: string;
  endDate!: string;

  constructor(
    private svc: CheckpointsService,
    private auth: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {

    const today = new Date();

    const before7 = new Date();
    before7.setDate(today.getDate() - 7);

    this.startDate = this.formatDate(before7);
    this.endDate = this.formatDate(today);

    this.load(true);

    setInterval(() => this.load(false), 60000);
  }

  formatDate(date: Date): string {

      const offset = date.getTimezoneOffset();
      const adjusted = new Date(date.getTime() - (offset * 60000));

      return adjusted.toISOString().slice(0, 16);
    }

  load(loading: boolean): void {

    this.loading = loading;
    this.loading_status = true;
    this.error = '';

    this.svc.list(this.startDate, this.endDate).subscribe({

      next: (res) => {

        this.data = res || [];
        this.loading = false;
        this.loading_status = false;
        this.lastUpdated = new Date();
      },

      error: () => {

        this.error = 'Erro buscando dados';
        this.loading = false;
        this.loading_status = false;
      }
    });
  }

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }

  downloadExcel(masterId: number) {
    // Se já estiver baixando este master → ignora
    if (this.downloadingMasterIds.includes(masterId)) {
      return;
    }

    // Adiciona o ID na lista de downloads ativos
    this.downloadingMasterIds.push(masterId);

    this.svc.downloadExcelPorMaster(masterId).subscribe({
      next: (blob) => {
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);

        a.href = url;
        a.download = `master_awb_${masterId}.xlsx`;
        a.click();

        window.URL.revokeObjectURL(url);
      },
      error: () => {
        console.error('Erro ao baixar Excel');
      },
      complete: () => {
        // Remove o master da lista ao finalizar
        this.downloadingMasterIds = this.downloadingMasterIds.filter(id => id !== masterId);
      }
    });
  }

  onDateChange(): void {

    if (!this.startDate || !this.endDate) {
      return;
    }

    const start = new Date(this.startDate);
    const end = new Date(this.endDate);

    // Data fim menor que início
    if (end < start) {

      alert('Data fim não pode ser menor que data início.');

      this.endDate = this.startDate;

      return;
    }

    const diffMs = end.getTime() - start.getTime();

    const diffDays = diffMs / (1000 * 60 * 60 * 24);

    // Máximo 7 dias
    if (diffDays > 7) {

      alert('Máximo permitido é 7 dias.');

      const limitDate = new Date(start);
      limitDate.setDate(limitDate.getDate() + 7);

      this.endDate = this.formatDate(limitDate);
    }

    // Recarrega automaticamente
    this.load(true);
  }
}
